import { motion } from "framer-motion";

export function PageHeader({ eyebrow, title, intro, children }) {
  return (
    <section className="relative pt-10 sm:pt-14 md:pt-16 pb-14 sm:pb-16 md:pb-20 theme-bg-primary border-b theme-border overflow-hidden">
      <div className="absolute inset-0 hero-radial opacity-50" />
      <div className="container-x relative">
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="max-w-3xl">
          {eyebrow && <div className="eyebrow mb-5">{eyebrow}</div>}
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold theme-text-primary leading-[1.05] tracking-tight">
            {title}
          </h1>
          <div className="divider-gold mt-6 mb-7" />
          {intro && <p className="theme-text-secondary text-base sm:text-lg leading-relaxed max-w-2xl">{intro}</p>}
          {children}
        </motion.div>
      </div>
    </section>
  );
}

export function SectionLabel({ children }) {
  return <div className="eyebrow mb-4">{children}</div>;
}
